<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                v-if="
                  this.$route.query.franchisee_id &&
                  this.positionName != 'FRANCHISEE ADMIN'
                "
                class="mr-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="HumanizePageName ? HumanizePageName : 'Users'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn v-can:add="'users'"
                  class="mx-2 mb-2 hover-primary"
                  fab
                  x-small
                  color="primary"
                  :to="
                    CurrentPageName == 'Franchisee_Staff_Listing'
                      ? `/franchisee-staffs/create?franchisee_id=${encryptIt(
                          filter.franchisee_id
                        )}`
                      : `/users/create`
                  "
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col lg="6" md="6" sm="12" cols="12">
                  <v-text-field
                    solo
                    rounded
                    hide-details="auto"
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <template v-if="CurrentPageName != 'Users_Listing'">
                  <v-col lg="3" md="3" sm="4" cols="12">
                    <v-autocomplete
                      solo
                      hide-details="auto"
                      rounded
                      ref="position"
                      placeholder="Filter by Position"
                      v-model="filter.position_id"
                      :items="filteredPositions"
                      label="Position"
                      @input="(page = 1), getData()"
                      prepend-inner-icon="mdi-account-tie-outline"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    lg="3"
                    md="3"
                    sm="4"
                    cols="12"
                    v-if="!this.$route.query.franchisee_id"
                  >
                    <v-autocomplete
                      solo
                      hide-details="auto"
                      rounded
                      ref="franchisee"
                      v-model="filter.franchisee_id"
                      :items="franchisees"
                      label="Franchisee"
                      placeholder="Filter by Franchisee"
                      @input="(page = 1), getData()"
                      prepend-inner-icon="mdi-store"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </template>
                <v-col lg="3" md="3" sm="4" cols="12">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col lg="3" md="3" sm="4" cols="12">
                  <v-autocomplete
                    ref="kyc_status"
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.is_kyc_verified"
                    @click:clear="(filter.is_kyc_verified = null), (page = 1)"
                    :items="kycStatusItems"
                    label="KYC Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by KYC Status"
                    prepend-inner-icon="mdi-shield-check"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">KYC Status</th>
                      <th class="text-left">First Name</th>
                      <th class="text-left">Middle Name</th>
                      <th class="text-left">Last Name</th>
                      <th class="text-left">User Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left" v-if="CurrentPageName !== 'Users_Listing'">Position</th>
                      <th class="text-left" v-if="CurrentPageName == 'Franchisee_Staff_Listing'">Employee Code</th>
                      <th class="text-left" v-if="CurrentPageName == 'Users_Listing'">Referral Code</th>
                      <th class="text-left">Created At</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="users.length != 0">
                    <tr v-for="(user, i) in users" :key="`user${i}`">
                      <td style="min-width: 85px">
                        {{ serialNoStarting + i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="user.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>User is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="user.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>User is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom v-if="user.is_kyc_verified == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="green"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-shield-check</v-icon>
                              </v-avatar>
                              Verified
                            </v-chip>
                          </template>
                          <span>KYC is Verified</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="user.is_kyc_verified == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="orange"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-shield-half-full</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>KYC is Pending</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="user.is_kyc_verified == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-shield-off</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>KYC is Rejected</span>
                        </v-tooltip>
                      </td>
                      <td>{{ user.first_name || "" }}</td>
                      <td>{{ user.middle_name || "" }}</td>
                      <td>{{ user.last_name || "" }}</td>
                      <td>{{ user.user_name || "" }}</td>
                      <td>{{ user.email || "" }}</td>
                      <td>{{ user.phone || "" }}</td>
                      <td v-if="CurrentPageName !== 'Users_Listing'">{{ user.position ? user.position.name : "" }}</td>
                      <td v-if="CurrentPageName == 'Franchisee_Staff_Listing'">{{ user.employee_code || "" }}</td>
                      <td v-if="CurrentPageName == 'Users_Listing'">{{ user.referral_code || "" }}</td>
                      <td style="min-width: 160px">{{ formatDate(user.created_at) }}</td>
                      <td class="text-right" style="min-width: 145px">
                        <template
                          v-if="CurrentPageName == 'Franchisee_Staff_Listing'"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mr-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/user-kyc-documents?user_id=${encryptIt(
                                  user.id
                                )}`"
                              >
                                <v-icon dark>
                                  mdi-card-account-details-star
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>View KYC Document</span>
                          </v-tooltip>
                        </template>
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'users'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="OpenWarning(user.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this user</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/users/${encryptIt(user.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this user</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'users'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(user.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this user</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td :colspan="CurrentPageName === 'Users_Listing' ? 12 : 13" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-row class="mt-4">
                <v-col cols="12" class="d-flex justify-space-between align-center">
                  <v-pagination v-model="page" :length="paginationLength">
                  </v-pagination>
                  <v-select
                    v-model="itemsPerPage"
                    :items="rowsPerPageOptions"
                    label="Rows per page"
                    dense
                    outlined
                    hide-details
                    @change="onRowsPerPageChange"
                    style="max-width: 150px;"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_user" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>User deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_user = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_user" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>User restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_user = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>
<style scoped>
.hover-primary:hover {
  background-color: secondary !important;
  color: rgb(3, 3, 3) !important;
}
</style>
<script>
import axios from "axios";
export default {
  name: "usersPage",
  data() {
    return {
      filter: {
        active: "",
        supervisor_id: "",
        role_id: "",
        position_id: "",
        show_deleted: false,
      },
      page: 1,
      itemsPerPage: 10,
      rowsPerPageOptions: [
        { text: "10", value: 10 },
        { text: "15", value: 15 },
        { text: "20", value: 20 },
        { text: "25", value: 25 },
        { text: "30", value: 30 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "ALL", value: -1 },
      ],
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_user: false,
      restore_user: false,
      is_restored_user: false,
      deleteDialog: false,
      to_be_deleted_id: "",
      users: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      kycStatusItems: [
        { id: "PENDING", text: "PENDING", value: "0" },
        { id: "APPROVED", text: "APPROVED", value: "1" },
        { id: "REJECTED", text: "REJECTED", value: "2" },
      ],
      positions: [],
      franchisees: [],
      isLoading: false,
      isExcelloading: false,
      ExportUsers: [],
      Export_users: [],
      CurrentPageName: "",
      HumanizePageName: "",
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Email: "email",
        Phone: "phone",
        Supervisor: "supervisor",
        "Is Active": "status",
      },
    };
  },
  computed: {
    filteredPositions() {
      if (this.CurrentPageName === 'Franchisee_Staff_Listing') {
        // Only show Franchisee Staff and Franchisee Admin positions
        return this.positions.filter(position => 
          position.text === 'FRANCHISEE STAFF' || position.text === 'FRANCHISEE ADMIN'
        );
      }
      return this.positions;
    }
  },
  watch: {
    page: "getData",
    $route() {
      this.getMasters();
    },
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    humanizeString(str) {
      // Plain-language page titles, keyed by route name.
      const titles = {
        Users_Listing: "Users",
        Franchisee_Staff_Listing: "Franchise Staff",
      };
      if (titles[str]) return titles[str];
      return str.replace(/_/g, " ").replace(" Listing", "").replace(" Page", "");
    },
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    async getMasters() {
      this.CurrentPageName = this.$route.name;
      this.positions = [];
      this.franchisees = [];
      this.filter.franchisee_id = this.$route.query.franchisee_id
        ? parseInt(this.decryptIt(this.$route.query.franchisee_id))
        : "";
      this.HumanizePageName = this.humanizeString(this.$route.name);
      await axios
        .get(`masters?context=user`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.positions.forEach((position) => {
            this.positions.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
          masters.franchisees.forEach((franchisee) => {
            this.franchisees.push({
              id: franchisee.id,
              text: franchisee.name,
              value: franchisee.id,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      await this.fetchPageDetails();
    },
    fetchPageDetails() {
      // var _this = this;
      if (this.positions) {
        let customer_position = this.positions.find(
          (p) => p.text == "CUSTOMER"
        );
        // let staff_position = this.positions.find(
        //   (p) => p.text == "FRANCHISEE STAFF"
        // );
        // let walker_position = this.positions.find((p) => p.text == "WALKER");

        // let owner_position = this.positions.find((p) => p.text == "SHIP OWNER");
        // let admin_position = this.positions.find(
        //   (p) => p.text == "INTERNAL INTERVIEWER"
        // );
        // let crew_manager_position = this.positions.find(
        //   (p) => p.text == "CREW MANAGER"
        // );

        switch (this.$route.name) {
          case "Franchisee_Staff_Listing":
            // Set initial filter to include both Franchisee Staff and Franchisee Admin
            this.UpdatePosition();

            break;
          case "Users_Listing":
            this.filter.position_id = customer_position ? customer_position.id : "";

            break;

          default:
            break;
        }
        this.getData();
      }
    },
    UpdatePosition() {
        const positionIdArray = [];
      const franchiseeStaffPosition = this.positions.find(
              (p) => p.text === "FRANCHISEE STAFF"
            );
            const franchiseeAdminPosition = this.positions.find(
              (p) => p.text === "FRANCHISEE ADMIN"
            );
            
            if (franchiseeStaffPosition) positionIdArray.push(franchiseeStaffPosition.id);
            if (franchiseeAdminPosition) positionIdArray.push(franchiseeAdminPosition.id);
            
            if (positionIdArray.length > 0) {
              this.filter.position_id = positionIdArray.join(",");
            }
    },
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.franchisee_id = this.filter.franchisee_id
        ? this.filter.franchisee_id
        : "";
      this.filter.is_kyc_verified = this.filter.is_kyc_verified
        ? this.filter.is_kyc_verified
        : "";

      // For Franchisee_Staff_Listing, only show Franchisee Staff or Franchisee Admin positions
      // For Users_Listing, only show CUSTOMER position
      let positionIds = '';
      if (this.$route.name === "Franchisee_Staff_Listing") {
        // If no position filter is set, use default franchisee staff/admin positions
        if (!this.filter.position_id) {
          // Find position IDs for Franchisee Staff and Franchisee Admin
          const franchiseeStaffPosition = this.positions.find(
            (p) => p.text === "FRANCHISEE STAFF"
          );
          const franchiseeAdminPosition = this.positions.find(
            (p) => p.text === "FRANCHISEE ADMIN"
          );
          
          const positionIdArray = [];
          if (franchiseeStaffPosition) positionIdArray.push(franchiseeStaffPosition.id);
          if (franchiseeAdminPosition) positionIdArray.push(franchiseeAdminPosition.id);
          
          // If we found the positions, use them; otherwise, keep the existing filter
          if (positionIdArray.length > 0) {
            positionIds = positionIdArray.join(",");
          }
        } else {
          // Use the selected position filter
          positionIds = this.filter.position_id;
        }
      } else if (this.$route.name === "Users_Listing") {
        // For Users_Listing, always filter by CUSTOMER position
        const customerPosition = this.positions.find(
          (p) => p.text === "CUSTOMER"
        );
        if (customerPosition) {
          positionIds = customerPosition.id;
        }
      } else {
        // For other pages, use the selected position filter or empty
        positionIds = this.filter.position_id ? this.filter.position_id : "";
      }

      // Handle "ALL" option by setting itemsPerPage to a large number when -1
      const actualRowsPerPage = this.itemsPerPage === -1 ? 1000000 : this.itemsPerPage;
      
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        actualRowsPerPage +
        "&role_id=4" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&position_id=" +
        positionIds +
        "&franchisee_id=" +
        this.filter.franchisee_id +
        "&is_kyc_verified=" +
        this.filter.is_kyc_verified +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`users?${query}`)
        .then((response) => {
          this.users = response.data.data;
          this.count = response.data.count;
          // Handle serial number starting point for "ALL" option
          this.serialNoStarting = this.itemsPerPage === -1 ? 0 : (this.page - 1) * this.itemsPerPage;
          // Handle pagination length for "ALL" option
          if (this.itemsPerPage === -1) {
            this.paginationLength = 1;
          } else {
            this.paginationLength = Math.ceil(this.count / this.itemsPerPage);
          }
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    onRowsPerPageChange() {
      this.page = 1; // Reset to first page when changing rows per page
      this.getData();
    },
    OpenWarning(request_id) {
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    async Delete_this(id) {
      this.delete_user = true;
      await axios
        .post(`/users/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_user = false;
          this.is_deleted_user = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async addToExcelData() {
      this.isExcelLoading = true;
      this.title = "Company Lists";
      let Export_users = [];
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.filter.active +
        "&roleId=" +
        this.filter.role_id;
      Export_users = await axios.get(`users?${query}`);
      this.Export_users = Export_users.data.data;

      this.Export_users.forEach((user) => {
        this.ExportUsers.push({
          sr_no: user.sr_no,
          name: user.name ? user.name.toUpperCase() : "",
          email: user.email ? user.email.toUpperCase() : "",
          phone: user.phone ? user.phone : "",

          supervisor: user.supervisor_id
            ? user.supervisor.name.toUpperCase()
            : "",
          status: user.active == 1 ? "YES" : "NO",
        });
      });
      this.isExcelLoading = false;
    },
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      let response = [];
      let query =
        "role_id=4" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&position_id=" +
        this.filter.position_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/users/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_user = true;
      await axios
        .post(`/users/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_user = false;
          this.is_restored_user = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
  },
};
</script>
